import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconedButton from '../../../shared/iconed-button';
import { SectionDetails } from '../../../shared/sectionable/styles';
import { recordStatisticsEvent } from '../../../../services/statistics-service';

const Container = styled(SectionDetails)`
  flex-direction: column;
  ${props => props.theme.isFeaturedLarge && `
    flex-direction: row;
  `};
`;

const Description = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  ${props => props.theme.isFeaturedLarge && `
    width: 74%;
    margin-right: 28px;
    flex-direction: row;
  `};
  ${props => props.theme.isXXLarge && `
    width: 73%;
    margin-right: 62px;
  `};
`;

const ButtonWrap = styled.div`
  margin-top: 42px;
  ${props => props.theme.isFeaturedMedium && `
    margin-top: 38px;
  `};
  ${props => props.theme.isFeaturedLarge && `
    width: 26%;
    margin-top: 0px;
    padding-left: 16px;
  `};
  ${props => props.theme.isXXLarge && `
    width: 27%;
    padding-left: 48px;
  `};
`;

const Caption = styled.p`
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 114%;
  color: ${props => props.theme.secondaryColor};
  letter-spacing: 0.1px;
  text-transform: uppercase;
  margin: 0;
`;

const Headline = styled.p`
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 21px;
  line-height: 130%;
  color: #252733;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  margin: 8px 0 0;
`;

const Text = styled.p`
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
  color: ${props => props.theme.bodyColor};
  letter-spacing: 0.1px;
  margin: 8px 0 0;
`;

const ViewButton = styled(IconedButton)`
  height: 42px;
  width: 154px;
  margin-top: 0px;
  padding: 3px 0px 3px 3px;
  ${props => props.theme.isFeaturedMedium && `
    width: 157px;
  `};
  ${props => props.theme.isFeaturedLarge && `
    width: 140px;
  `};
  ${props => props.theme.isXXLarge && `
    width: 154px;
  `};
  border: 1px solid ${props => props.theme.secondaryColor};
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  box-sizing: border-box;
  text-align: center;
  text-transform: uppercase;
  background-color: ${props => props.theme.bodyBackgroundColor} !important;
  color: ${props => props.theme.bodyColor};
  outline: none;

  &:hover {
    border: 1px solid ${props => props.theme.bodyColor};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
  }

  &:active {
    border: 1px solid ${props => props.theme.bodyColor};
    box-shadow: none;
  }

  & > span.icon-lw {
    height: 34px;
    width: 34px;
    font-size: 22px;
    background-color: ${props => props.theme.secondaryColor};
    color: #ffffff;
    padding: 5px;
  }

  & > span:not(.icon-lw) {
    flex-grow: 2;
    font: ${props => props.theme.fontWeightHeavy} 14px/120% ${props => props.theme.fontFamilyBody};
    text-align: center;
    padding: 9px;
  }
`;

export default function Details({ fund }) {
  const { id, name, monthlyUpdateFileUrl } = fund;

  const viewLink = e => {
    e && e.preventDefault();
    recordStatisticsEvent({
      id,
      statisticable: 'fund',
      event: 'fund_profile_monthly_report_clicked',
      clicked_url: monthlyUpdateFileUrl,
      page: window.location.pathname,
    });
    window.open(monthlyUpdateFileUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Container>
      <Description>
        <Caption>update report</Caption>
        <Headline>{`${name} Latest Update`}</Headline>
        <Text>
          For the most recent results including performance for the last reporting period,
          please download the recent update from the manager
        </Text>
      </Description>
      <ButtonWrap>
        <ViewButton onClick={viewLink}>
          <span className="icon-lw icon-lw-view-update" />
          <span>view update</span>
        </ViewButton>
      </ButtonWrap>
    </Container>
  );
}

Details.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    monthlyUpdateFileUrl: PropTypes.string.isRequired,
  }).isRequired,
};
